import { CreateMedicineDto, Medicine } from "@/types/medicine";
import { AdminBaseService } from "./admin-base.service";
import { PaginatedResult } from "./base.service";
import api from "./api";
import { FilterDto } from "@/hooks/filterUtils";

class MedicinesService extends AdminBaseService {
  constructor() {
    super("/medicine");
  }

  async getMedicines(dto: FilterDto): Promise<PaginatedResult<Medicine>> {
    const response = await api.post<PaginatedResult<Medicine>>("/medicine/getAll", dto);
    return response.data;
  }

  async getMedicine(id: string): Promise<Medicine> {
    return await this.get<Medicine>(`/${id}`);
  }

  async createMedicine(data: CreateMedicineDto): Promise<Medicine> {
    return await this.post<Medicine>("", data);
  }

  async updateMedicine(id: string, data: Partial<Medicine>): Promise<Medicine> {
    return await this.put<Medicine>(`/${id}`, data);
  }

  async deleteMedicine(id: string): Promise<void> {
    return await this.delete(`/${id}`);
  }
}

export const medicinesService = new MedicinesService();
